import Carousel from './renderers/Carousel';
import Gallery from './renderers/Gallery';
import SideBySideText from './renderers/SideBySideText';
import SideBySideTextMedia from './renderers/SideBySideTextMedia';
import BuyNow from './renderers/BuyNow';
import BuyAddons from './renderers/BuyAddons';
import FAQs from './renderers/FAQ';
import VideoGuides from './renderers/VideoGuides';
import Blog from './renderers/Blog';
import Map from './renderers/Map';
import ThreeColumns from './renderers/ThreeColumns';
import Intro from './renderers/Intro';
import DiffJson from 'diff-json';

let renderMapping = {
  'carousel': Carousel,
  'gallery': Gallery,
  'side-by-side-text-media': SideBySideTextMedia,
  'side-by-side-text': SideBySideText,
  'buy-now': BuyNow,
  'buy-addons': BuyAddons,
  'faqs': FAQs,
  'video-guides': VideoGuides,
  'blog': Blog,
  'map': Map,
  'three-columns': ThreeColumns,
  'intro': Intro
}

export default class Render {
  constructor(options) {
    this.path = options.path;
    this.data = options.data;
    this.element = options.element;
    this.flux = options.flux;

    console.log(this.data.get('type'))
    if (renderMapping[this.data.get('type')].constructor == undefined)
      return console.log("No renderer for ", this.data.get('type'));

    this.renderClass = new renderMapping[this.data.get('type')]
                              ({parentElement: this.element, data: this.data});

    this.flux._stores.sections.on('change', () => {
      let previousSection = this.flux._stores.sections.state.get('previousSections').getIn(this.path);
      let section = this.flux._stores.sections.state.get('sections').getIn(this.path);

      if (previousSection && section) {
        let diffs = DiffJson.diff(previousSection.toJS(),
                                  section.toJS());

        if (diffs.length > 0) {
          this.renderClass.reRender(section);
        }
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/Render.js